import { render, staticRenderFns } from "./adminOwnerDetail.vue?vue&type=template&id=a6e59cbe&scoped=true"
import script from "./adminOwnerDetail.vue?vue&type=script&lang=js"
export * from "./adminOwnerDetail.vue?vue&type=script&lang=js"
import style0 from "./adminOwnerDetail.vue?vue&type=style&index=0&id=a6e59cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e59cbe",
  null
  
)

export default component.exports